export class PushLoading {
  static readonly type = '[Loading] Push';
}

export class PopLoading {
  static readonly type = '[Loading] Pop';
}
